export const filterProduct = (userSetting, product) => {
  if (userSetting.display_rule_type === 1) return true
  if (userSetting.display_rule_type === 3) {
    return !shouldFilterProduct(userSetting, product)
  } else if (userSetting.display_rule_type === 2) {
    return shouldFilterProduct(userSetting, product)
  }
}

const shouldFilterProduct = (userSetting, product) => {
  return isSkuInUserSettings(userSetting, product) ||
    isTagInUserSettings(userSetting, product) ||
    isCollectionInUserSettings(userSetting, product)
}

const isSkuInUserSettings = (userSetting, product) => {
  return userSetting.skus.filter(s => s === product.sku).length > 0
}

const isTagInUserSettings = (userSetting, product) => {
  if (!product.tags) return false
  return userSetting.tags.filter(s => {
    var tags = product.tags.map(t => t.toLowerCase())
    var pos = tags.indexOf(s.toLowerCase());
    return pos >= 0
  }).length > 0
}

const isCollectionInUserSettings = (userSetting, product) => {
  if (!product.collections) return false
  return userSetting.collections.filter((s) => {
    var collections = product.collections.map(c => c.title ? c.title.toLowerCase() : c.toLowerCase())
    var pos = collections.indexOf(s.toLowerCase());
    return pos >= 0
  }).length > 0
}
